import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { SERVICES } from "@/data/services";
import { Mail, MapPin, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-brand-ink text-white mt-20">
      <div className="container-x py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <div className="[&_span]:!text-white">
              <Logo />
            </div>
            <p className="mt-5 text-white/60 text-sm leading-relaxed max-w-sm">
              A digital studio building brands, products, and growth engines for ambitious teams worldwide.
            </p>
            <div className="mt-6 space-y-2.5 text-sm text-white/60">
              <a href="mailto:support@telstranics.com" data-testid="footer-email" className="flex items-center gap-2 hover:text-white transition-colors"><Mail className="w-4 h-4 shrink-0" /> support@telstranics.com</a>
              <a href="tel:+18045655569" data-testid="footer-phone" className="flex items-center gap-2 hover:text-white transition-colors"><Phone className="w-4 h-4 shrink-0" /> +1 (804) 565-5569</a>
              <div className="flex items-start gap-2"><MapPin className="w-4 h-4 shrink-0 mt-0.5" /> <span>1207 Delaware Ave #2392<br />Wilmington, DE 19806</span></div>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-widest text-white/40 mb-4">Services</div>
            <ul className="space-y-2 text-sm">
              {SERVICES.slice(0, 4).map((s) => (
                <li key={s.slug}>
                  <Link data-testid={`footer-service-${s.slug}`} to={`/services/${s.slug}`} className="text-white/70 hover:text-white transition-colors">{s.title}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-widest text-white/40 mb-4">More</div>
            <ul className="space-y-2 text-sm">
              {SERVICES.slice(4).map((s) => (
                <li key={s.slug}>
                  <Link data-testid={`footer-more-${s.slug}`} to={`/services/${s.slug}`} className="text-white/70 hover:text-white transition-colors">{s.title}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs uppercase tracking-widest text-white/40 mb-4">Company</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" data-testid="footer-about" className="text-white/70 hover:text-white">About</Link></li>
              <li><Link to="/pricing" data-testid="footer-pricing" className="text-white/70 hover:text-white">Pricing</Link></li>
              <li><Link to="/blog" data-testid="footer-blog" className="text-white/70 hover:text-white">Blog</Link></li>
              <li><Link to="/contact" data-testid="footer-contact" className="text-white/70 hover:text-white">Contact</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-sm">
          <div className="text-white/50">© {new Date().getFullYear()} TelstraNics. All rights reserved.</div>
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            <Link to="/privacy-policy" data-testid="footer-privacy" className="text-white/60 hover:text-white">Privacy Policy</Link>
            <Link to="/terms-of-use" data-testid="footer-terms" className="text-white/60 hover:text-white">Terms of Use</Link>
            <Link to="/refund-policy" data-testid="footer-refund" className="text-white/60 hover:text-white">Refund Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
